















































import PapeletaAprobar from "@/components/admin/transacciones/PapeletaAprobar.vue";
import Vue from "vue";
import DistanciaService, { DistanciaCreateDto } from "@/api/DistanciaService";
import PedidoService, {
  PedidoCreatedDto,
  PedidoDto
} from "@/api/pedido/PedidoService";

export default Vue.extend({
  components: {
    PapeletaAprobar
  },
  metaInfo: {
    title: "Papeletas Pendientes"
  },
  data() {
    return {
      dialog: false,
      dato: {
        id: 0
      } as PedidoDto,
      headers: [
        { text: "Id", value: "id" },
        { text: "Identificación", value: "cliente.identificacion" },
        { text: "Nombre", value: "cliente.nombre" },
        { text: "Apellido", value: "cliente.apellido" },
        { text: "Monto", value: "displayTotal" },
        { text: "Estado", value: "displayEstado" },
        { text: "Acción", value: "actions", sortable: false }
      ],
      datos: [] as PedidoDto[]
    };
  },
  methods: {
    setDefaultItem() {
      const newDto = {
        id: 0
      };
      this.dato = newDto;
    },
    editItem(item: PedidoDto) {
      this.dato = item;
      this.dialogChange(true);
    },
    newItem() {
      this.setDefaultItem();
      this.dialogChange(true);
    },
    dialogChange(value: boolean) {
      this.dialog = value;
    },
    getAll() {
      PedidoService.getPedidos()
        .then(response => {
          this.datos = response;
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            icon: "error",
            title: "Pendientes",
            text: "No se pudo obtener"
          });
        });
    }
  },
  mounted() {
    this.getAll();
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === false) {
        this.setDefaultItem();
      }
    }
  }
});
